/*
 * Application Insights JavaScript SDK - Common, 2.7.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

/**
 * System variables for a telemetry item.
 */
var Envelope =
/** @class */
function () {
  function Envelope() {
    /**
     * Envelope version. For internal use only. By assigning this the default, it will not be serialized within the payload unless changed to a value other than #1.
     */
    this.ver = 1;
    /**
     * Sampling rate used in application. This telemetry item represents 1 / sampleRate actual telemetry items.
     */

    this.sampleRate = 100.0;
    /**
     * Key/value collection of context properties. See ContextTagKeys for information on available properties.
     */

    this.tags = {};
  }

  return Envelope;
}();

export { Envelope };